import { ActionType } from '../infrastructure/actionTypes';

export interface IStoredRouteState {
  storedRoute: string;
}

const storedRouteInitialState: IStoredRouteState = {
    storedRoute: "",
};

export default (state = storedRouteInitialState, action: any) => {
  switch (action.type) {
    case ActionType.NAVIGATING:
      return { storedRoute: action.path };
    default:
      return state;

  }
};


// WEBPACK FOOTER //
// ./src/reducers/storedRoute.ts